/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Describes the highlighting mode to use for the series in the chart.
 */
export var SeriesHighlightingMode = /*@__PURE__*/ (function (SeriesHighlightingMode) {
    /**
     * Highlighting mode is determined by the component.
     */
    SeriesHighlightingMode[SeriesHighlightingMode["Auto"] = 0] = "Auto";
    /**
     * No highlighting is defined at the chart level. Individual series may have local highlight settings.
     */
    SeriesHighlightingMode[SeriesHighlightingMode["None"] = 1] = "None";
    /**
     * Series will brighten when hovered, and, if applicable brighten indiviudal shapes or markers.
     */
    SeriesHighlightingMode[SeriesHighlightingMode["BrightenSpecific"] = 2] = "BrightenSpecific";
    /**
     * Series will brighten when hovered.
     */
    SeriesHighlightingMode[SeriesHighlightingMode["Brighten"] = 3] = "Brighten";
    /**
     * Series will fade if they aren't the hovered series, and, if applicable other shapes in the hovered series will fade.
     */
    SeriesHighlightingMode[SeriesHighlightingMode["FadeOthersSpecific"] = 4] = "FadeOthersSpecific";
    /**
     * Series will fade if they aren't the hovered series, and, if applicable other shapes in the hovered series will fade.
     */
    SeriesHighlightingMode[SeriesHighlightingMode["FadeOthers"] = 5] = "FadeOthers";
    return SeriesHighlightingMode;
})({});
/**
 * @hidden
 */
export var SeriesHighlightingMode_$type = /*@__PURE__*/ markEnum('SeriesHighlightingMode', 'Auto,0|None,1|BrightenSpecific,2|Brighten,3|FadeOthersSpecific,4|FadeOthers,5');
